import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService, TournamentTeam, TeamPlayer } from 'src/app/services/data-service.service';

@Component({
  selector: 'tournament-teams',
  templateUrl: './teams.component.html',
  styleUrls: ['./teams.component.scss']
})
export class TeamsComponent implements OnInit {
  public displayTeamInfo = false;
  public players: TeamPlayer[] = [];
  public team: TournamentTeam = new TournamentTeam();

  constructor(public ds: DataService) { }

  ngOnInit(): void { }

  public closeTeamInfo(): void {
    this.displayTeamInfo = false;
  }

  public onSelectTeam(t: TournamentTeam): void {
    this.team = t; 
    this.displayTeamInfo = true;
    if (this.ds.currentTournament.isTeamEvent) {
      let p = this.ds.currentTournament.teams.find(x => x.id === t.id);
      if (p) {
        this.players = p.players;
      }
    }
  }
}
